
import menu from './en-US/menu';
import form from './en-US/form';
import validation from './en-US/validation';
import table from './en-US/table';
import models from './en-US/model';
import _enum from './en-US/enum';
import pages from './en-US/pages';
export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  ...menu,
  ...table,
  ...form,
  ...validation,
  ...models,
  ..._enum,
  ...pages
};
